import { SponsoredProductTrackingDevice } from '@/productDiscovery/SponsoredProducts/interfaces/SponsoredProductTracking';

export const getDevice = (): SponsoredProductTrackingDevice =>
  window.matchMedia('(any-pointer:coarse) and (max-width: 1024px)').matches
    ? 'mobile'
    : 'desktop';
